module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "delay_pause_black.5457561d.png" + "?" + Date.now();